import React from 'react';
import { Box } from '@mui/material';
import PageHeader from './PageHeader';
import EmptyOperationalState from './EmptyOperationalState';

/**
 * placeholder 페이지 공통 셸.
 * 이번 PR은 메뉴 조립 구조(권한 기반 노출)가 목적이므로 본문은 준비 중 카드만 둔다.
 */
const PlaceholderPage = ({ title, description }) => (
  <Box>
    <PageHeader title={title} description={description} />
    <EmptyOperationalState
      variant="preparing"
      title="화면 준비 중이에요"
      description="권한과 메뉴 구조는 연결되어 있어요. 실제 운영 기능은 API 계약이 준비되는 순서대로 채워집니다."
    />
  </Box>
);

export default PlaceholderPage;
